interface BaseCardProps {
  title: string;
  children: React.ReactNode;
  allowScroll?: boolean;
}

export function BaseCard({ title, children, allowScroll }: BaseCardProps) {
  return (
    <div className="card">
      <div className="card-header-relative"> {title}</div>
      {allowScroll ? (
        <div className="card-body-scroll">{children}</div>
      ) : (
        <> {children} </>
      )}
    </div>
  );
}
